import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import {Link} from "react-router-dom"; 
import $ from 'jquery';

export default class Profile extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content">    
            <div className="container pt-5">
              <div className='row'>
                <div className='col-md-6'>
                  <form className='form-main-wrapper'>
                    <div className='form-head'>Log In to Your Skola Account!</div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Username or email *</label>
                      <input type="email" className="form-control" placeholder="Email or username" />
                    </div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Password *</label>
                      <input type="email" className="form-control" placeholder="Password" />
                    </div>
                    <div className="form-group row">
                      <div className="form-check col-lg-7">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        <label className="form-check-label" for="exampleCheck1">Remember me</label>
                      </div>
                      <div className="form-check col-lg-5" style={{textAlign:"right"}}>
                        <a href='/lost-password'>Forgot Password</a>
                      </div>
                    </div>
                    <div className="form-group mt-4" style={{textAlign:"right"}}>
                      <button type="submit" className="btn btn-secondary">Log in</button>
                    </div>
                  </form>
                </div>
                <div className='col-md-6'>
                  <form className='form-main-wrapper'>
                    <div className='form-head'>Sign Up and Start Learning!</div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Email address *</label>
                      <input type="email" className="form-control" placeholder="Email" />
                    </div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Username *</label>
                      <input type="email" className="form-control" placeholder="Username" />
                    </div>
                    <div className="form-group">
                      <label for="exampleFormControlInput1">Password *</label>
                      <input type="email" className="form-control" placeholder="Password" />
                    </div>
                    <div className="form-group mt-4" style={{textAlign:"right"}}>
                      <button type="submit" className="btn btn-secondary">Register</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            
        </div>
        
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/ivano/profile.jsx